module.exports = __webpack_public_path__ + "static/media/token-preview-dogge.6610aab0.png";